import joinTimeAndDate from 'utils/dateAndTimes/methods/joinTimeAndDate';
import dateAndTimeConstants from 'utils/dateAndTimes/constants';
import {
  getHoursDifferenceByTimes,
  setTime,
} from 'utils/dateAndTimes/methods/methods';
import { validationSchemaForDirect } from 'state/direct-order/validationSchema';

const getDateAndTimeFromMoment = (momentDate) => ({
  date: momentDate.format('YYYY-MM-DD'),
  time: momentDate.format('HH:mm'),
});

const getAutocompletedPickupToTimeAndDate = ({
  originalTimes,
  validations,
}) => {
  // This should be replaced with validations when offering validations for DIRECT / TODAY
  const workingDayTo = validationSchemaForDirect.working_day[1];
  const { pickup_time_from, pickup_time_to } = originalTimes;
  const fromTimeAndDate = joinTimeAndDate(
    originalTimes[
      `${dateAndTimeConstants.STOP_TYPES.pickup}_${dateAndTimeConstants.TIME_FIELD_PARAMS.from}`
    ],
    originalTimes[
      `${dateAndTimeConstants.STOP_TYPES.pickup}_${dateAndTimeConstants.DATE_FIELD_PARAMS.from}`
    ]
  );

  const timeDifference = getHoursDifferenceByTimes(
    pickup_time_from,
    pickup_time_to || workingDayTo
  );
  const isTimeDifferenceMoreThanMargin =
    timeDifference >=
    dateAndTimeConstants.CONSTANTS_FOR_RULES.DEFAULT_PICKUP_MARGIN_IN_HOURS;

  const toTimeAndDate = isTimeDifferenceMoreThanMargin
    ? setTime(fromTimeAndDate, workingDayTo)
    : fromTimeAndDate
        .clone()
        .add(
          dateAndTimeConstants.CONSTANTS_FOR_RULES
            .DEFAULT_PICKUP_MARGIN_IN_HOURS,
          'hours'
        );
  const { date, time } = getDateAndTimeFromMoment(toTimeAndDate);
  return {
    [`${dateAndTimeConstants.STOP_TYPES.pickup}_${dateAndTimeConstants.TIME_FIELD_PARAMS.to}`]:
      time,
    [`${dateAndTimeConstants.STOP_TYPES.pickup}_${dateAndTimeConstants.DATE_FIELD_PARAMS.to}`]:
      date,
  };
};

export default getAutocompletedPickupToTimeAndDate;
